export default __webpack_public_path__ + "static/media/rotor-front.63c48729.svg";